import {
  PURCHASE_REGISTER_REPORT_REQUEST,
  PURCHASE_REGISTER_REPORT_SUCCESS,
  PURCHASE_REGISTER_REPORT_FAILURE,

  GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST,
  GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS,

  GET_ITEMS_OF_PURCHASE_BILL_REQUEST,
  GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_ITEMS_OF_PURCHASE_BILL_SUCCESS,

  GET_BROKERS_OF_PURCHASE_BILL_REQUEST,
  GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_BROKERS_OF_PURCHASE_BILL_SUCCESS,

  GET_LOTS_OF_PURCHASE_BILL_REQUEST,
  GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_LOTS_OF_PURCHASE_BILL_SUCCESS,

  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST,
  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS,
  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE,
} from "../types/purchase-bill-report-types";

const initialState = {
  accountsOfPurchaseBill: {},
  itemsOfPurchaseBill: {},
  brokersOfPurchaseBill: {},
  lotsOfPurchaseBill: {},
  purchaseBillsInvoiceNumberOfPurchaseBill: {},
  purchaseRegisterReport: {},
  loading: false,
  error: null,
};

const purchaseReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_REGISTER_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case PURCHASE_REGISTER_REPORT_SUCCESS: {
      return {
        ...state,
        purchaseRegisterReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case PURCHASE_REGISTER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS: {
      return {
        ...state,
        accountsOfPurchaseBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_ITEMS_OF_PURCHASE_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_ITEMS_OF_PURCHASE_BILL_SUCCESS: {
      return {
        ...state,
        itemsOfPurchaseBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_BROKERS_OF_PURCHASE_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_BROKERS_OF_PURCHASE_BILL_SUCCESS: {
      return {
        ...state,
        brokersOfPurchaseBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case GET_LOTS_OF_PURCHASE_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_LOTS_OF_PURCHASE_BILL_SUCCESS: {
      return {
        ...state,
        lotsOfPurchaseBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS: {
      return {
        ...state,
        purchaseBillsInvoiceNumberOfPurchaseBill: { ...(action.payload || {}) },
        loading: false,
        error: null
      };
    }
    case GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default purchaseReportReducer;
